import variables from './variables';
export { variables };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-const/es/index.js
// module id = 1287
// module chunks = 0